// ChatNotificationModal.js
import React, { useMemo } from 'react';
import {
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
  Paper,
  Box,
} from '@mui/material';

const ChatNotificationModal = ({
  notificationschat,
  onClose,
  setNotifications,
  setUnreadCount,
  markAsRead,
}) => {
  // Group by sender, keeping only the latest message
  const latestBySender = useMemo(() => {
    const sorted = [...notificationschat].sort(
      (a, b) => new Date(b.created_at) - new Date(a.created_at)
    );
    const unique = new Map();
    sorted.forEach((notif) => {
      if (!unique.has(notif.sender)) {
        unique.set(notif.sender, notif);
      }
    });
    return Array.from(unique.values());
  }, [notificationschat]);

  const handleClick = (id) => {
    markAsRead(id);
    onClose();
  };

  return (
    <Paper
      sx={{
        position: 'fixed',
        top: 60,
        left: { xs: 0, sm: 'auto' },
        right: { xs: 0, sm: 10 },
        mx: { xs: 'auto', sm: 0 },
        zIndex: 1300,
        width: 320,
        maxWidth: '90vw',
        borderRadius: 2,
        boxShadow: 3,
        backgroundColor: '#fff',
      }}
    >
      <Typography variant="h6" sx={{ p: 2 }}>
        New Messages:
      </Typography>

      <Box sx={{
        maxHeight: 400,
        overflowY: latestBySender.length > 4 ? 'auto' : 'visible',
      }}>
        <List>
          {latestBySender.length > 0 ? (
            latestBySender.map((notification) => (
              <ListItem
                key={notification.id}
                button
                onClick={() => handleClick(notification.id)}
                sx={{
                  bgcolor: notification.is_read ? 'inherit' : '#e3f2fd',
                }}
              >
                <ListItemAvatar>
                  <Avatar src={notification.sender_profile_image_url} />
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Typography
                      variant="subtitle1"
                      sx={{
                        fontWeight: notification.is_read ? 'normal' : 'bold',
                      }}
                      noWrap
                    >
                      {notification.sender_name}
                    </Typography>
                  }
                  secondary={
                    notification.message_preview.length > 30
                      ? notification.message_preview.slice(0, 30) + '...'
                      : notification.message_preview
                  }
                />
              </ListItem>
            ))
          ) : (
            <Typography variant="body2" sx={{ px: 2, py: 4, textAlign: 'center' }}>
              No notifications
            </Typography>
          )}
        </List>
      </Box>
    </Paper>
  );
};

export default ChatNotificationModal;
